import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Menu } from "../components";

import background1 from "../assets/background1.png";
import background2 from "../assets/background2.png";
import background3 from "../assets/background3.png";
import background4 from "../assets/background4.png";
import background5 from "../assets/background5.png";
import background6 from "../assets/background6.png";
import background7 from "../assets/background7.png";
import background8 from "../assets/background8.png";
import background9 from "../assets/background9.png";
import background10 from "../assets/background10.png";
import background11 from "../assets/background11.png";
import background12 from "../assets/background12.png";
import background13 from "../assets/background13.png";

const backgrounds = [
  background1,
  background2,
  background3,
  background4,
  background5,
  background6,
  background7,
  background8,
  background9,
  background10,
  background11,
  background12,
  background13,
];

function HomeContainer({ children }) {
  const [currentBackgroundIndex, setCurrentBackgroundIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentBackgroundIndex(
        (prevIndex) => (prevIndex + 1) % backgrounds.length
      );
    }, 7000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, []);
  return (
    <div
      className="container"
      style={{
        backgroundImage: `url(${backgrounds[currentBackgroundIndex]})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        transition: "background-image 1s ease-in-out",
        minHeight:"100vh",
      }}
    >
      <Menu />
      {children}
    </div>
  );
}

export default HomeContainer;
